<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      @openDetailDialog="openDetailDialog"
      @reload="reload"
    >
      <page-header ref="header" slot="header" @query="getData" />
    </page-main>
    <DetailDialog
      :visible.sync="detailDialogParams.visible"
      :title="
        $l('INDEX.tips_view_packaging_info') || '查看修改订单包装需求信息'
      "
      :orderPackingCode="detailDialogParams.code"
    />
  </div>
</template>
<script>
import DetailDialog from '../detail/dialog.vue'
import BaseTable from '@/mixins/base-table'
import PageMain from './main.vue'
import PageHeader from './header.vue'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, DetailDialog },
  props: { orderCode: { type: String, default: '' } },
  data() {
    return {
      loading: false,
      detailDialogParams: {
        visible: false,
        code: '',
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .pendingOrderDemandPackingListApi({
          orderCode: this.orderCode,
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openDetailDialog({ orderPackingCode }) {
      this.detailDialogParams = {
        visible: true,
        code: orderPackingCode,
      }
    },
  },
}
</script>
